import { render, staticRenderFns } from "./inventory-stock-bulk-update.vue?vue&type=template&id=0960bc4a&"
import script from "./inventory-stock-bulk-update.vue?vue&type=script&lang=js&"
export * from "./inventory-stock-bulk-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports